module.exports = __webpack_public_path__ + "img/social-media-color-blocks-cjdr.ccc4b70d.png";